import React, { useEffect, useState } from 'react';
import { ModuleBase, HeadingTag, ResponsiveImage, Link, MediaLightboxCarousel } from '@/components';
import Arrow from '@/assets/arrow.svg';
import classNames from 'classnames';

const MediaColumnsPortraitModule = ({ data }) => {
  const { headingTitle, preHeading, description, cta, mediaItems, numberOfItems } = data || {};
  const [isOpen, setIsOpen] = useState(null);
  const [colNum, setColNum] = useState(2);
  const [widthClasses, setWidthClasses] = useState('w-[327px] md:w-[332px] lg:w-[392px] xl:w-[392px]');
  const [mediaSize, setMediaSize] = useState({
    widths: { xs: 327, sm: 327, md: 332, lg: 392, xl: 392, xxl: 392 },
    heights: { xs: 439, sm: 439, md: 443, lg: 524, xl: 524, xxl: 524 },
  });

  useEffect(() => {
    if (numberOfItems === 'One' || numberOfItems === 'Three' || numberOfItems === 'Four') {
      let widths = {};
      let heights = {};
      if (numberOfItems === 'One') {
        setColNum(1);
        widths = { xs: 327, sm: 327, md: 332, lg: 392, xl: 392, xxl: 392 };
        heights = { xs: 439, sm: 439, md: 443, lg: 524, xl: 524, xxl: 524 };
        setWidthClasses('w-[327px] md:w-[332px] lg:w-[392px] xl:w-[392px]');
      } else if (numberOfItems === 'Three') {
        setColNum(3);
        widths = { xs: 327, sm: 327, md: 220, lg: 310, xl: 392, xxl: 392 };
        heights = { xs: 439, sm: 439, md: 293, lg: 413, xl: 524, xxl: 524 };
        setWidthClasses('w-[327px] md:w-[220px] lg:w-[310px] xl:w-[392px]');
      } else if (numberOfItems === 'Four') {
        setColNum(4);
        widths = { xs: 327, sm: 327, md: 172, lg: 236, xl: 300, xxl: 364 };
        heights = { xs: 439, sm: 439, md: 229, lg: 315, xl: 400, xxl: 485 };
        setWidthClasses('w-[327px] md:w-[172px] lg:w-[236px] xl:w-[300px]');
      }
      setMediaSize({
        widths,
        heights,
      });
    }
  }, [numberOfItems]);

  return (
    <>
      <MediaLightboxCarousel
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        slides={mediaItems}
        imageWidths={{ xs: 327, sm: 327, md: 332, lg: 392, xl: 525, xxl: 525 }}
        imageHeights={{ xs: 439, sm: 439, md: 443, lg: 524, xl: 700, xxl: 700 }}
        imageContainerWidthClassName="w-[327px] md:w-[332px] lg:w-[392px] xl:w-[525px]"
        imageContainerHeightClassName="h-[439px] md:h-[443px] lg:h-[524px] xl:h-[700px]"
      />

      <ModuleBase data={data} className="m-auto max-w-[1304px] px-6 md:px-10">
        <div className={classNames('gap-2 md:flex', description ? 'min-h-[180px]' : '')}>
          <div className="title-wrapper w-full">
            {preHeading && (
              <p className="text-small text-subheading font-montserrat font-semibold uppercase md:text-base">
                {preHeading}
              </p>
            )}
            {headingTitle && <HeadingTag data={headingTitle} className="text-h3 mb-6 mt-2 font-montserrat md:mt-4" />}
          </div>
          <div className="flex w-full flex-col md:max-w-[332px] lg:max-w-[496px]">
            {description && (
              <div className="mb-6 grow text-paragraph md:mt-10">
                <div
                  dangerouslySetInnerHTML={{ __html: description }}
                  className="font-montserrat text-sm lg:text-base"
                ></div>
              </div>
            )}
            {cta && (
              <Link className="flex items-center gap-1 self-end border-b border-solid font-montserrat" link={cta}>
                {cta.text} <Arrow role="presentation" className="scale-75 stroke-black" />
              </Link>
            )}
          </div>
        </div>
        <div
          className={classNames(
            'grid grid-cols-1',
            colNum === 1
              ? 'md:grid-cols-1'
              : colNum === 2
                ? 'md:grid-cols-2'
                : colNum === 3
                  ? 'md:grid-cols-3'
                  : 'md:grid-cols-4',
            'm-auto mt-10 w-fit justify-items-center gap-6',
          )}
        >
          {mediaItems.map((slide, index) => (
            <div key={index} className={classNames('m-auto mb-10 md:m-0', widthClasses)}>
              <div className="mb-6 cursor-pointer lg:mb-10" onClick={() => setIsOpen(String(index))}>
                <ResponsiveImage image={slide} widths={mediaSize.widths} heights={mediaSize.heights} />
              </div>
              {slide.title && <div className="text-subheading mb-2">{slide.title}</div>}
              {slide.description && (
                <div
                  dangerouslySetInnerHTML={{ __html: slide.description }}
                  className="font-montserrat text-sm lg:text-base"
                ></div>
              )}
            </div>
          ))}
        </div>
      </ModuleBase>
    </>
  );
};
export default MediaColumnsPortraitModule;
